import type { ContactMessageIntent } from "@wags/profile-contracts/contact-session.contract.ts";

export function asksAboutListing(intent: ContactMessageIntent | undefined) {
    return intent !== "similar";
}
